import React, { useEffect, useRef, useState } from 'react';

// Eases a displayed number from 0 up to `value` on mount/when value changes —
// purely a presentation animation over a real, already-fetched number, never
// a substitute for the actual data.
export default function AnimatedNumber({ value, duration = 900, decimals = 0, suffix = '', prefix = '' }) {
  const [display, setDisplay] = useState(0);
  const startRef = useRef(null);
  const fromRef = useRef(0);

  useEffect(() => {
    if (typeof value !== 'number' || isNaN(value)) { setDisplay(value); return; }
    fromRef.current = 0;
    startRef.current = null;
    let raf;
    const step = (ts) => {
      if (startRef.current === null) startRef.current = ts;
      const progress = Math.min(1, (ts - startRef.current) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(fromRef.current + (value - fromRef.current) * eased);
      if (progress < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  if (typeof value !== 'number' || isNaN(value)) return <>{prefix}{value ?? '—'}{suffix}</>;
  return <>{prefix}{display.toFixed(decimals)}{suffix}</>;
}
